import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const names = ['María', 'Sofía', 'Valentina', 'Camila', 'Luciana', 'Isabella', 'Martina', 'Catalina', 'Florencia', 'Daniela', 'Ana', 'Gabriela', 'Paula', 'Carolina', 'Andrea', 'Julieta', 'Romina', 'Agustina', 'Micaela', 'Natalia'];
const cities = ['Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Medellín', 'Córdoba', 'Rosario', 'Quito', 'Ciudad de México', 'Guadalajara', 'Caracas', 'Mendoza', 'Mar del Plata', 'La Plata'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 1;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    const showNotification = () => {
      setNotification({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4500);
    };
    // First notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);
    // Then every 10-15 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 10000 + Math.random() * 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-170">
      <AnimatePresence data-id="element-171">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        x: -20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-2xl shadow-2xl border border-brand-accent/20 p-4 max-w-xs flex items-start gap-3" data-id="element-172">
            <div className="w-10 h-10 rounded-full bg-brand-cta/10 flex items-center justify-center shrink-0" data-id="element-173">
              <ShoppingBagIcon size={20} className="text-brand-cta" data-id="element-174" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-175">
              <p className="text-sm font-semibold text-brand-text leading-tight" data-id="element-176">
                {notification.name} de {notification.city}
              </p>
              <p className="text-xs text-brand-text/60 mt-0.5" data-id="element-177">
                compró el Mega Kit hace {notification.minutes} min
              </p>
              <div className="flex items-center gap-1 mt-1" data-id="element-178">
                <span className="text-xs text-brand-accent font-medium" data-id="element-179">
                  ✓ Compra verificada
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}